import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from '../link';
import { styled } from '../styled';
import { Typography } from '../typography';
/** only allow a limited list of html-tags as valid tags */
const allowNode = (node) => {
    if (node.type === 'html') {
        if (node.value && /<\/?(li|br|ul|p|h[1-6]|b) *\/*>/.test(node.value)) {
            return true;
        }
        return false;
    }
    return true;
};
const StyledReactMarkdown = styled(ReactMarkdown ?? _jsx(_Fragment, {})) `
    > p {
        margin-top: 0;
    }
    ul {
        margin-top: 0;
        padding-left: 0;
    }
    > p:only-child {
        margin: 0;
    }
    pre {
        white-space: pre-line;
    }
    > ul > li,
    > div > ul > li,
    > span > li {
        margin-left: ${({ theme }) => theme.spacing(2)};
        padding-left: ${({ theme }) => theme.spacing(0.5)};
    }
`;
const SpanRoot = (props) => (_jsx("span", { ...props }));
const DivRoot = (props) => (_jsx("div", { ...props }));
const MarkdownLink = (props) => {
    return _jsx(Link, { ...props, target: "_blank", rel: "noreferrer" });
};
export const Markdown = (props) => {
    const { blockText, children, renderers: renderersProps, linkComponent, ...typographyProps } = props;
    const renderers = {
        root: blockText ? DivRoot : SpanRoot,
        link: linkComponent ?? MarkdownLink,
        ...(renderersProps ?? {})
    };
    return children ? (_jsx(Typography, { component: "span", ...typographyProps, children: _jsx(StyledReactMarkdown, { source: children, escapeHtml: false, allowNode: allowNode, renderers: renderers }) })) : null;
};
Markdown.displayName = 'Markdown';
const MARKDOWN_CHARACTERS = [
    '\\',
    '`',
    '*',
    '_',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '#',
    '+',
    '-',
    '.',
    '!'
];
export function escape(text) {
    return text.replace(new RegExp(`([${MARKDOWN_CHARACTERS.join('\\')}])`, 'g'), '\\$1');
}
